import { StateStorage } from 'zustand/middleware'
import { createStore } from '../.'

interface UserActivityInterface {
  lastUserActivityAt: string | undefined
  registerUserActivity: () => void
}

export const createUserActivityStore = (storage: StateStorage) =>
  createStore<UserActivityInterface>(
    storage,
    (set) => ({
      lastUserActivityAt: undefined,
      registerUserActivity: () => {
        set({ lastUserActivityAt: new Date().toISOString() })
      },
    }),
    {
      persist: {
        name: 'userActivity',
        version: 0,
      },
    }
  )
